module.exports = __webpack_public_path__ + "img/ic_burger_magazin-active.53106264.svg";